import { clientApiCall } from "./apiCallWrapper";
import type {
  IncrementProductViewsResponse,
  ProductId,
  ProductPhotoIdsResponse,
} from "./types/product";

/** Клиентский API данных товаров. */
export default (_axios: any, config: any) => ({
  getProductPhotoIds(
    ids: ProductId[],
    reset = false,
  ): Promise<ProductPhotoIdsResponse | null> {
    if (!ids.length) {
      return Promise.resolve({});
    }
    return clientApiCall<ProductPhotoIdsResponse>(
      `${config.API_SERVER_URL}/client/product/getProductPhotoIds`,
      {
        api: "product.getProductPhotoIds",
        method: "post",
        params: {
          ids: ids.join(","),
          reset,
        },
      },
    );
  },

  /** +1 к счётчику просмотров карточки товара. Ботов не считаем. */
  incrementProductViews(
    id: ProductId,
  ): Promise<IncrementProductViewsResponse | null> {
    const productId = Number(id);
    if (!Number.isInteger(productId) || productId <= 0) {
      return Promise.resolve(null);
    }
    return clientApiCall<IncrementProductViewsResponse>(
      `${config.API_SERVER_URL}/client/product/incrementProductViews`,
      {
        api: "product.incrementProductViews",
        method: "post",
        params: { id: productId },
        skipForRobots: true,
      },
    );
  },
});
